import React, { useMemo, useContext } from "react";
import { Card, Row, Col, Typography, Segmented, Tabs, Select, message } from "antd";
import { categorize, getFieldLabel, describeColor } from "./utils";
import AppContext from "../../contexts/AppContext";


const { Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

function ColorOption({ hex }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span aria-hidden style={{ width: 14, height: 14, borderRadius: "50%", background: hex, border: "1px solid rgba(0,0,0,0.15)", boxShadow: "0 1px 2px rgba(0,0,0,0.08)", flex: "0 0 14px" }} />
      <span>{describeColor(hex)}</span>
      <span style={{ color: "#9ca3af", fontSize: 11 }}>{hex.toUpperCase()}</span>
    </div>
  );
}

/**
 * 配置面板（Dual / Multiple）
 * 中文说明：Dual 模式下仅允许设置 primary / secondary；Multiple 模式可对所有键位逐一映射。
 * Tips(EN): If DB contains `color`, it will be normalized into primary/white on save.
 */
export default function ConfigOptions({ selectionMode, setSelectionMode, hasSpecialColor, configKeys, cfgIndex, setCfgIndex, palette }) {
  const { selectedRole } = useContext(AppContext);
  const otherKeys = useMemo(() => (configKeys || []).filter((k) => k !== "color" && k !== "primaryColor" && k !== "secondaryColor"), [configKeys]);
  const grouped = useMemo(() => categorize(otherKeys), [otherKeys]);

  return (
    <Card
      title={<span className="cms-section-title text-[#1f2a44]">Configuration Options</span>}
      className="overflow-hidden rounded-[26px] border border-[#e3e9f8] shadow-[0_18px_40px_rgba(30,52,120,0.08)]"
      headStyle={{ borderBottom: "1px solid #e8edf8", padding: "18px 22px", minHeight: "unset" }}
      bodyStyle={{ padding: "22px" }}
      style={{ marginTop: 12 }}
    >
      <div style={{ marginBottom: 16 }}>
        <Segmented value={selectionMode}
          onChange={(val) => {
            if (selectedRole?.permissionLevel === 0 && String(val) === "opt3") {
              message.error('Your package level does not support Custom Theme option. Please contact support to upgrade your package.');
              return;
            }
            setSelectionMode(String(val));
          }}
          options={[{ label: "Simple Theme", value: "opt2" }, { label: "Custom Theme", value: "opt3" }]} block />
      </div>

      {selectionMode === "opt2" && (
        <>
          {["primaryColor", "secondaryColor"].map((dbKey) => (
            <Row key={dbKey} justify="space-between" align="middle" style={{ marginBottom: 12, padding: "6px 0" }}>
              <Col flex="auto"><Text style={{ fontSize: 15, color: "#334155" }}>{getFieldLabel(dbKey)}</Text></Col>
              <Col>
                <Select allowClear placeholder={`Select ${getFieldLabel(dbKey)}`} size="middle" value={typeof cfgIndex[dbKey] === "number" ? String(cfgIndex[dbKey]) : undefined} onChange={(val) => setCfgIndex((s) => ({ ...s, [dbKey]: val !== undefined ? Number(val) : undefined }))} style={{ width: 264 }}>
                  {palette.map((hex, idx) => (
                    <Option key={idx} value={String(idx)}><ColorOption hex={hex} /></Option>
                  ))}
                </Select>
              </Col>
            </Row>
          ))}

        </>
      )}

      {selectionMode === "opt3" && (
        <Card size="small" style={{ marginTop: 8, borderRadius: 18, borderColor: "#e6ebf8", boxShadow: "none", background: "#fcfdff" }}>
          <Tabs defaultActiveKey="Home">
            {["Top", "Home", "Services", "Contact", "Bottom"].map((group) => (
              <TabPane tab={group} key={group}>
                {grouped[group].length === 0 ? (
                  <Text type="secondary">No fields in this group.</Text>
                ) : (
                    grouped[group].map((dbKey) => (
                      <Row key={dbKey} justify="space-between" align="middle" style={{ marginBottom: 12, padding: "6px 0" }}>
                        <Col flex="auto"><Text style={{ fontSize: 15, color: "#334155" }}>{getFieldLabel(dbKey)}</Text></Col>
                        <Col>
                          <Select allowClear placeholder={`Select ${getFieldLabel(dbKey)}`} size="middle" value={typeof cfgIndex[dbKey] === "number" ? String(cfgIndex[dbKey]) : undefined} onChange={(val) => setCfgIndex((s) => ({ ...s, [dbKey]: val !== undefined ? Number(val) : undefined }))} style={{ width: 264 }}>
                          {palette.map((hex, idx) => (
                            <Option key={idx} value={String(idx)}><ColorOption hex={hex} /></Option>
                          ))}
                        </Select>
                      </Col>
                    </Row>
                  ))
                )}
              </TabPane>
            ))}
          </Tabs>
        </Card>
      )}
    </Card>
  );
}
